var _rect, _rect2, _rect3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtueCardFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 284,
    viewBox: "0 0 208 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.561644,
    y: 0.561644,
    width: 206.877,
    height: 282.877,
    rx: 23.8174,
    fill: "#0F0F0F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.561644,
    y: 0.561644,
    width: 206.877,
    height: 282.877,
    rx: 23.8174,
    stroke: "url(#paint0_linear_9641_574)",
    strokeWidth: 0.876712
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.561644,
    y: 0.561644,
    width: 206.877,
    height: 282.877,
    rx: 23.8174,
    stroke: "url(#paint1_radial_9641_574)",
    strokeWidth: 0.876712
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.839 244.049C109.793 244.081 109.758 244.127 109.739 244.18L109.478 244.891C109.274 245.45 108.951 245.957 108.53 246.377C108.11 246.797 107.603 247.121 107.045 247.325L106.333 247.585C106.28 247.604 106.235 247.639 106.203 247.685C106.171 247.731 106.153 247.786 106.153 247.841C106.153 247.897 106.171 247.952 106.203 247.998C106.235 248.044 106.28 248.079 106.333 248.098L107.045 248.358C107.603 248.562 108.11 248.886 108.53 249.306C108.951 249.726 109.274 250.233 109.478 250.792L109.739 251.503C109.758 251.555 109.793 251.601 109.839 251.633C109.884 251.665 109.939 251.682 109.995 251.682C110.051 251.682 110.106 251.665 110.151 251.633C110.197 251.601 110.232 251.555 110.251 251.503L110.512 250.792C110.716 250.233 111.039 249.726 111.46 249.306C111.88 248.886 112.387 248.562 112.945 248.358L113.656 248.098C113.709 248.079 113.754 248.044 113.787 247.998C113.819 247.952 113.836 247.897 113.836 247.841C113.836 247.786 113.819 247.731 113.787 247.685C113.754 247.639 113.709 247.604 113.656 247.585L112.945 247.325C112.387 247.121 111.88 246.797 111.46 246.377C111.039 245.957 110.716 245.45 110.512 244.891L110.251 244.18C110.232 244.127 110.197 244.081 110.151 244.049C110.106 244.017 110.051 244 109.995 244C109.939 244 109.884 244.017 109.839 244.049ZM99.5291 247.825H105.349L105.349 247.84C105.349 248.062 105.417 248.279 105.544 248.46C105.671 248.642 105.851 248.78 106.059 248.855L106.061 248.856L106.77 249.116C107.218 249.279 107.624 249.538 107.961 249.875C108.298 250.212 108.557 250.619 108.721 251.066L108.98 251.775L108.981 251.777C109.057 251.985 109.195 252.164 109.376 252.291C109.558 252.419 109.774 252.487 109.996 252.487C110.218 252.487 110.435 252.419 110.616 252.291C110.798 252.164 110.936 251.985 111.011 251.777L111.012 251.775L111.272 251.066C111.414 250.677 111.629 250.319 111.904 250.01L114.23 252.723C114.822 253.414 114.812 254.437 114.206 255.116L105.718 264.622C104.995 265.431 103.729 265.431 103.007 264.622L94.5192 255.116C93.9131 254.437 93.9027 253.414 94.495 252.723L98.1496 248.46C98.4948 248.057 98.9987 247.825 99.5291 247.825Z",
    fill: "#D2D2D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9641_574",
    x1: 104,
    y1: 1,
    x2: 104,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523E35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9641_574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.57 246.298) rotate(-143.027) scale(90.0873 56.473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtueCardFront);
export default __webpack_public_path__ + "static/media/ftue_card_front.096e64a84169e94450455c5c72c01b26.svg";
export { ForwardRef as ReactComponent };